export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";